import defaultRedirectHandler from './modules/defaultRedirectHandler.js';
export var ClientConfigKeys = [
    'audience',
    'clientId',
    'clientDomain',
    'authDomain',
    'redirectPath',
];
var Client = (function () {
    function Client(config) {
        this.valid = true;
        this.defaultScope = 'openid profile email offline_access';
        this.defaultRouteHandler = defaultRedirectHandler;
        this.config = config;
        this.verifyConfig();
    }
    Client.prototype.verifyConfig = function () {
        var _this = this;
        ClientConfigKeys.forEach(function (key) {
            if (typeof _this.config[key] !== 'string') {
                _this.valid = false;
                console.error("Missing ".concat(key, " from client config"));
            }
        });
        if (!this.valid) {
            return console.error('Invalid Online Identity Client Configuration. Please see above errors.');
        }
        this.redirectUri = "".concat(this.config.__disableHttps ? 'http' : 'https', "://").concat(this.config.clientDomain).concat(this.config.redirectPath);
    };
    return Client;
}());
export default Client;
//# sourceMappingURL=Client.js.map